<template>
  <div class="container-planscardlist">
    <div class="wrapper-plans">
      <AccordionQna v-for="(qna, qnaIndex) in qnas" :key="`qna_${qnaIndex}`">
        <template #header>
          <p class="question">{{ t(qna.question) }}</p>
        </template>

        <p v-for="(answer, answerIndex) in qna.answer" :key="`answer_${answerIndex}`" class="answer">
          {{ t(answer) }}
        </p>
        <component v-if="qna.component" :is="qna.component" />
      </AccordionQna>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import AccordionQna from '@/components/shared/base/AccordionQna.vue';
import { QnaItem } from '@/types/components';

const { t } = useI18n();

withDefaults(
  defineProps<{
    title?: string;
    qnas: QnaItem[];
  }>(),
  {
    title: '',
    qnas: () => [],
  }
);
</script>

<style scoped lang="scss">
.container-planscardlist {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  border-radius: 16px;
  scroll-margin-top: 68px;
}

.wrapper-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @include respond-to(mobile-portrait) {
    width: 100%;
  }
}

.wrapper-tabs {
  display: flex;
  justify-content: space-between;
}

.wrapper-plans {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
</style>
